import { useTranslation } from 'react-i18next';
import type { PlayerAssignment } from '../../types/game';

interface RoleCounterProps {
  assignments: PlayerAssignment[];
}

export function RoleCounter({ assignments }: RoleCounterProps) {
  const { t } = useTranslation('game');

  const blackCount = assignments.filter((a) => a.role === 'black').length;
  const sheriffCount = assignments.filter((a) => a.role === 'sheriff').length;
  const redCount = assignments.filter((a) => a.role === 'red').length;
  // grey + maybe-black + maybe-red all count as unresolved
  const greyCount = assignments.filter(
    (a) => a.role === 'grey' || a.role === 'maybe-black' || a.role === 'maybe-red',
  ).length;

  return (
    <div className="flex flex-col gap-2">
      <h4 className="font-mono text-xs tracking-widest uppercase text-mafia-muted">Прогресс</h4>

      <div className="grid grid-cols-2 gap-2">
        <div className="flex flex-col items-center p-2 rounded border border-mafia-crimson/30 bg-mafia-crimson/5">
          <span className="font-sans tabular-nums text-xl font-bold text-mafia-crimson">
            {blackCount}<span className="text-mafia-muted text-sm">/3</span>
          </span>
          <span className="text-[10px] font-mono text-mafia-muted uppercase tracking-wider">
            {t('board.counter.mafia')}
          </span>
        </div>

        <div className="flex flex-col items-center p-2 rounded border border-mafia-gold/30 bg-mafia-gold/5">
          <span className="font-sans tabular-nums text-xl font-bold text-mafia-gold">
            {sheriffCount}<span className="text-mafia-muted text-sm">/1</span>
          </span>
          <span className="text-[10px] font-mono text-mafia-muted uppercase tracking-wider">
            Шериф
          </span>
        </div>

        <div className="col-span-2 flex flex-col items-center p-2 rounded border border-red-700/30 bg-red-950/10">
          <span className="font-sans tabular-nums text-xl font-bold text-red-400">
            {redCount}<span className="text-mafia-muted text-sm">/6</span>
          </span>
          <span className="text-[10px] font-mono text-mafia-muted uppercase tracking-wider">
            {t('board.counter.civilians')}
          </span>
        </div>
      </div>

      {greyCount > 0 && (
        <p className="text-[10px] text-center text-mafia-muted font-sans tabular-nums">
          Осталось назначить: {greyCount}
        </p>
      )}
      {greyCount === 0 && (
        <p className="text-[10px] text-center text-mafia-gold/80 font-sans">
          Все роли назначены ✓
        </p>
      )}
    </div>
  );
}
